import { render, staticRenderFns } from "./FreelanceInformation.vue?vue&type=template&id=1c32068a&scoped=true"
import script from "./FreelanceInformation.vue?vue&type=script&lang=js"
export * from "./FreelanceInformation.vue?vue&type=script&lang=js"
import style0 from "./FreelanceInformation.vue?vue&type=style&index=0&id=1c32068a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32068a",
  null
  
)

export default component.exports